import React, { useContext } from 'react';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import _merge from 'lodash/merge';
import { getContext } from 'common';

import Avatar from 'components/Avatar';

import { ChipContext } from './Chip';

const DEFAULT_STYLE = RTL => RTL ? ({
  marginLeft: `-${Tokens.SPACING.SPACING_4}`
}) : ({
  marginRight: `-${Tokens.SPACING.SPACING_4}`
});

export interface ChipAvatarProps extends React.ComponentPropsWithRef<'div'> {
  /** The content of the Avatar, in text or <img /> */
  children: React.ReactNode;
  /** @ignore */
  style?: React.CSSProperties
}

/** All props will be provided to `Avatar` component, the size of the `ChipAvatar` is read from `ChipContext`. */
const ChipAvatar = React.forwardRef<HTMLElement, ChipAvatarProps>((props: ChipAvatarProps, ref) => getContext(({ RTL }) => {
  const {
    style,
    ...otherProps
  } = props;
  const {
    size
  } = useContext(ChipContext);
  const avatarProps = {
    style: _merge({}, DEFAULT_STYLE(RTL), style || {}),
    diameter: size === 'medium' ? '2rem' : '1.25rem',
    ...otherProps
  };
  return <Avatar {...avatarProps} ref={ref} />;
}));

ChipAvatar.displayName = 'ChipAvatar';

ChipAvatar.defaultProps = {
  style: {}
};

export default ChipAvatar;
